import { combineReducers } from "redux";

import invoices from "./invoices";
import clients from "./clients";
import auth from "./auth";
import profiles from "./profiles";
import upload from "./upload";
import categories from "./categories";
import items from "./items";
import contactus from "./contactus";
import companies from "./companies";
import userGroups from "./groups";
import users from "./users";
import rentals from "./rentals";
import buildings from "./buildings";
import units from "./units";
import transactions from "./transaction";
import letters from "./letters";
import accounts from "./account";
import purchaseInvoices from "./purchaseInvoices.js";
import attendance from "./attendanceReducer.js";
import payrolls from "./payrollReducer.js";
import tax from "./tax.js";
import assets from "./assets.js";
import barcodeSettings from "./barcodeSettings.js";
import costcenters from "./costCenters.js";
import profitCenters from "./profitCenters.js";
import projects from "./projects.js";
import smsProviders from "./smsProviders.js";
import notifications from "./notifications.js";
import smsSettings from "./smsSettings";
import vouchers from "./vouchers.js";
import coupons from "./coupons.js";
import emailSettingsReducer from "./EmailSettingsReducer.js";
import communication from "./communication.js";
import ProductPackageReducer from "./ProductPackages.js";
import features from "./features.js";
import translation from "./translation.js";
import accountSettings from "./accountSettings.js";
import clinic from "./clinic.js";
import properties from "./properties.js";
import property from "./property.js";
import messaging from "./messaging.js";

export default combineReducers({
  invoices,
  clients,
  auth,
  profiles,
  upload,
  categories,
  items,
  contactus,
  companies,
  userGroups,
  users,
  rentals,
  buildings,
  units,
  transactions,
  letters,
  accounts,
  purchaseInvoices,
  attendance,
  payrolls,
  tax,
  assets,
  barcodeSettings,
  costcenters,
  profitCenters,
  projects,
  smsProviders,
  notifications,
  smsSettings,
  vouchers,
  coupons,
  emailSettingsReducer,
  communication,
  ProductPackageReducer,
  features,
  translation,
  accountSettings,
  properties,
  clinic,
  property,
  messaging,
});
